import axios from 'axios'

// Forecast de produccion de platos (On Demand). Pega al Laravel de catering
// (baseURL /api/v1 ya configurada globalmente en main.js con el Bearer token).
export default {
  obtener () {
    return axios.get('/forecast/platos')
  },
  fichas () {
    return axios.get('/forecast/fichas')
  },
  descargar (fecha, canal, formato, cocinaId, categoria) {
    return axios.get('/forecast/precantidades/descargar', {
      params: {
        fecha,
        canal,
        formato,
        cocina: cocinaId || undefined,
        categoria: categoria || undefined
      },
      responseType: 'blob'
    })
  },
  descargarInsumos (desde, hasta, canal, cocinaId, categoria) {
    return axios.get('/forecast/insumos/descargar', {
      params: {
        desde,
        hasta,
        canal,
        cocina: cocinaId || undefined,
        categoria: categoria || undefined
      },
      responseType: 'blob'
    })
  },
  historyPdf (id) {
    return axios.get('/forecast/historial/pdf', {
      params: { id },
      responseType: 'blob'
    })
  },
  history (reporte, cocinaId, canal, id) {
    return axios.get('/forecast/historial', {
      params: {
        reporte,
        cocina: cocinaId === null || cocinaId === undefined || cocinaId === '' ? undefined : cocinaId,
        canal: canal || undefined,
        id: id || undefined
      }
    })
  }
}
